import { useCallback } from 'react';
import { useHeaderHeight } from '@/shared/components/header-height-context';

export const useScrollToFirstError = () => {
    const headerHeight = useHeaderHeight() || 0;
    const scrollToFirstError = useCallback(() => {
        const element = document.querySelector('.alert__error, .border-red-500');

        if (!element) return;
        const elementPosition =
            element.getBoundingClientRect().top + window.scrollY - headerHeight - 80;

        setTimeout(() => {
            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth',
            });
        }, 200);
    }, [headerHeight]);

    return scrollToFirstError;
};